var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99988 6C4.23845 6 1.99988 8.23858 1.99988 11V17C1.99988 19.7614 4.23845 22 6.99988 22H16.9999C19.6775 22 21.8635 19.8953 21.9937 17.25H17.4999C15.705 17.25 14.2499 15.7949 14.2499 14C14.2499 12.2051 15.705 10.75 17.4999 10.75H21.9937C21.8635 8.10472 19.6775 6 16.9999 6H6.99988ZM17.4999 12.25H21.9999V15.75H17.4999C16.5334 15.75 15.7499 14.9665 15.7499 14C15.7499 13.0335 16.5334 12.25 17.4999 12.25ZM5.99988 16.75C5.58566 16.75 5.24988 17.0858 5.24988 17.5C5.24988 17.9142 5.58566 18.25 5.99988 18.25H11.9999C12.4141 18.25 12.7499 17.9142 12.7499 17.5C12.7499 17.0858 12.4141 16.75 11.9999 16.75H5.99988ZM17.4999 13.25C17.0857 13.25 16.7499 13.5858 16.7499 14C16.7499 14.4142 17.0857 14.75 17.4999 14.75H17.6999C18.1141 14.75 18.4499 14.4142 18.4499 14C18.4499 13.5858 18.1141 13.25 17.6999 13.25H17.4999Z",
    fill: "#D5DAE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4878 4.99302C18.7667 3.00165 16.6606 1.716 14.4414 2.1729L5.84064 3.94363C4.04426 4.31348 2.58887 5.4977 1.82764 7.06305C3.0151 5.5053 4.89022 4.5 7.00015 4.5H17.0001C17.8813 4.5 18.7215 4.67534 19.4878 4.99302Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletLarge);
export default __webpack_public_path__ + "static/media/wallet_large.f0c32039db39351f570f76452345dd94.svg";
export { ForwardRef as ReactComponent };